module.exports = __webpack_public_path__ + "6343c5f3dd7fa8c24c66a2d66f95d158.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/train/view/home/images/5.png
// module id = 181
// module chunks = 1